"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

export default function Modal({ open, setOpen, children, minWidth }) {
  return (
    <div className="flex">
      <Dialog open={open} onClose={setOpen} className="relative z-[50000]">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-[#0e1219]/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-[#181d25] px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:max-w-sm sm:p-6 md:max-w-[90%] data-closed:sm:translate-y-0 data-closed:sm:scale-95"
              style={{ minWidth: minWidth ?? null }}
            >
              {children}
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
